/**
 * Shipped AI Spatie permission names — keep in sync with
 * backend/app/Ai/Config/AiFeatures.php SHIPPED + AiFeaturePermissions.
 */
export const AI_PERMISSIONS_PARENT = "ai";

export const SHIPPED_AI_PERMISSIONS = [
  "ai.timesheet.anomaly_check",
  "ai.timesheet.bulk_anomaly_check",
  "ai.timesheet.anomaly_read",
  "ai.care_watch.view",
  "ai.copilot.query",
];

export const isShippedAiPermission = (permissionName) =>
  SHIPPED_AI_PERMISSIONS.includes(permissionName);

export const isAiPermissionsParent = (item) =>
  item?.name === AI_PERMISSIONS_PARENT;

export const sortAiPermissionChildren = (children = []) => {
  if (!children.length) return children;

  const byName = new Map(children.map((child) => [child.name, child]));
  const shipped = SHIPPED_AI_PERMISSIONS.map((name) => byName.get(name)).filter(
    Boolean
  );
  const rest = children
    .filter((child) => !isShippedAiPermission(child.name))
    .sort((a, b) =>
      String(a.description || "").localeCompare(String(b.description || ""))
    );

  return [...shipped, ...rest];
};

/** Uncheck coming-soon AI children; sort shipped Timesheet permissions first. */
export const normalizeAiPermissionNode = (item) => {
  if (!isAiPermissionsParent(item) || !item.children?.length) {
    return item;
  }

  const children = sortAiPermissionChildren(item.children).map((child) => ({
    ...child,
    isChecked: isShippedAiPermission(child.name)
      ? Boolean(child.isChecked ?? child.status)
      : false,
  }));

  return {
    ...item,
    isChecked: Boolean(item.isChecked ?? item.status),
    children,
  };
};

export const normalizePermissionsList = (permissions = []) =>
  permissions.map((item) => normalizeAiPermissionNode(item));

/** Collect permission ids for role save — skip unshipped AI children only. */
export const collectRolePermissionIds = (permissions = []) => {
  const ids = [];

  permissions.forEach((item) => {
    if (isAiPermissionsParent(item)) {
      if (item.isChecked) {
        ids.push(item.id);
      }
      item.children?.forEach((child) => {
        if (child.isChecked && isShippedAiPermission(child.name)) {
          ids.push(child.id);
        }
      });
      return;
    }

    if (item.isChecked) {
      ids.push(item.id);
    }
    item.children?.forEach((child) => {
      if (child.isChecked) {
        ids.push(child.id);
      }
    });
  });

  return ids;
};
